import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

export interface MessageBoxButton {
  name: string;
  class: string;
  icon?: string;
}

export interface MessageBoxData {
  header?: boolean;
  closable?: boolean;
  title?: string;
  content: string;
  buttons: Array<MessageBoxButton>;
}

@Component({
  selector: 'message-box',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss']
})
export class MessageBoxComponent {

  @Input() data: MessageBoxData = null;
  @Output() selected: EventEmitter<MessageBoxButton> = new EventEmitter<MessageBoxButton>()

  constructor(public modalRef: BsModalRef) { }

  emit(button: MessageBoxButton) {
    this.selected.emit(button);
    this.modalRef.hide();
  }
}
